"use client";

import { Card, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import emailConfimation from "@/assets/signup_process/confirmEmail.png";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import LOCAL_STORAGE from "@/constants/local-storage";
import ROUTE_URLS from "@/constants/route-urls";
import useAuth from "@/contexts/auth-context";
import useLanguage from "@/contexts/language-context";
import { getAccessToken } from "@/helpers/auth-helpers";
import { EmailConfirmationMessages } from "@/messages/emailConfirmation/email-confirmation.messages";

type EmailConfirmationProps = {
  messages: EmailConfirmationMessages;
};

export default function EmailConfirmation({ messages }: EmailConfirmationProps) {
  const { token } = useParams();
  const { confirmEmail, isEmailConfirmed } = useAuth();
  const router = useNavigate();
  const { lang } = useLanguage();
  const accessToken = getAccessToken();

  useEffect(() => {
    if (!accessToken) {
      if (token) localStorage.setItem(LOCAL_STORAGE.accessTokenKey, token.toString());
    }

    confirmEmail({ token: token.toString() });

    if (isEmailConfirmed) router(ROUTE_URLS.serviceDashboard(lang), { replace: true });
  }, [token, accessToken, isEmailConfirmed, confirmEmail, router, lang]);

  return (
    <MDBox width="100%" height="var(--full-vh)" display="flex" alignItems="center" justifyContent="center">
      <Card
        sx={{
          width: "80%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <MDBox
          p={6}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={6}
        >
          <img
            src={emailConfimation}
            alt={messages.emailConfirmationIllustration}
            style={{ objectFit: "contain" }}
            width={500}
            height={500}
          />

          <MDTypography variant="h3">{messages.confirmEmailTitle}</MDTypography>

          <CircularProgress size={60} />
        </MDBox>
      </Card>
    </MDBox>
  );
}
